export default {
  'fr-FR': {}
};
